import styled, { css } from 'styled-components';

const IsVariableStyles = css`
  color: var(--color-status-amber);
  border: 1px solid var(--color-status-amber);
  background-color: var(--color-badge-warning-bg);
`;

const VariableButton = styled.div<{
  isVariable: boolean;
  isListItem?: boolean;
}>`
  width: ${(props) => (props.isListItem ? '32px' : '68px')};
  margin-left: ${(props) => (props.isListItem ? '0px' : '8px')};
  margin-right: ${(props) => (props.isListItem ? '12px' : '0px')};
  height: 22px;
  background-color: var(--color-bg-input);
  border: 1px solid var(--color-grey-7);
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  ${(props) => props.isVariable && IsVariableStyles};

  &:hover {
    opacity: 0.7;
  }
`;

export default VariableButton;
